import script from "./AlertComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertComponent.vue?vue&type=script&setup=true&lang=js"

import "./AlertComponent.vue?vue&type=style&index=0&id=347b14ac&lang=scss&scoped=true"

import exportComponent from "/home/csoetaert/projects/adct-client-companion/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347b14ac"]])

export default __exports__